import { HalfFloatType, PMREMGenerator } from 'three';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';
import { getAdaptiveConfigurationValue } from '../AdaptiveConfigurationDto';
import { SCENE_ENVIRONMENT_KEY } from '../viewTree/assets/AssetsManager';
export class HdrEnvironment {
    constructor(settings, assetsManager) {
        this.settings = settings;
        this.assetsManager = assetsManager;
    }
    init(renderer, scene) {
        const pMREMGenerator = new PMREMGenerator(renderer);
        pMREMGenerator.compileEquirectangularShader();
        return new Promise((resolve, reject) => {
            if (!this.settings.hdr) {
                resolve();
                return;
            }
            new RGBELoader().setDataType(HalfFloatType).load(getAdaptiveConfigurationValue(this.settings.hdr), (texture) => {
                const envTexture = pMREMGenerator.fromEquirectangular(texture).texture;
                scene.environment = envTexture;
                if (this.assetsManager) {
                    this.assetsManager.registerAsset(SCENE_ENVIRONMENT_KEY, envTexture);
                }
                texture.dispose();
                pMREMGenerator.dispose();
                resolve();
            }, () => { }, reject);
        });
    }
}
//# sourceMappingURL=HdrEnvironment.js.map